import { render, staticRenderFns } from "./WaitForSubmission.vue?vue&type=template&id=32955683&scoped=true"
import script from "./WaitForSubmission.vue?vue&type=script&lang=ts"
export * from "./WaitForSubmission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32955683",
  null
  
)

export default component.exports